import React from "react";

const ConnectedPlatformCard = ({
  platform,
  loading,
  index,
  handlePlatformConnect,
  handlePlatformDisconnect,
  handleConfigurePlatformClick,
}) => {
  return (
    <div
      key={index}
      className="p-5 bg-gray-50 rounded-2xl shadow-sm hover:shadow-none border border-transparent hover:border-primary-500 transition-all flex flex-col gap-2"
    >
      <div className="grow flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <p className="text-xs font-bold uppercase text-rose-400 tracking-widest">
            {platform.tagline || "PREMIUM"}
          </p>
          <div className="flex items-center gap-3">
            <div className="flex-none h-fit w-fit p-2.5 bg-white rounded shadow-xs">
              <div
                className="rounded object-contain overflow-hidden flex items-center justify-center"
                style={{ width: "20px", height: "20px" }}
              >
                <img
                  width="20"
                  height="20"
                  src={platform.icon}
                  alt={platform.name}
                  className="flex-grow-0"
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
            </div>
            <p className="text-md font-semibold">{platform.name}</p>
            <div className="ml-auto">
              <div className="inline-block relative">
                <button
                  type="button"
                  disabled={loading}
                  className={`px-6 py-2 rounded-lg shadow-md ${
                    platform.isConnected
                      ? "border-none bg-transparent text-black"
                      : "border bg-[#221C51] text-white "
                  }`}
                  onClick={
                    !platform.isConnected
                      ? () => handlePlatformConnect(platform.slug)
                      : () => handleConfigurePlatformClick(platform.slug)
                  }
                >
                  {platform.isConnected ? "Configure" : "Connect"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <p className="text-sm font text-gray-500">{platform.description}</p>
        {platform.isConnected ? (
          <button
            type="button"
            className={`px-6 py-2 rounded-lg shadow-md ${
              loading
                ? "border-none bg-transparent text-black"
                : "border text-white bg-[#000] hover:bg-red-600 transition duration-300"
            }`}
            onClick={
              platform.isConnected && !loading
                ? () => handlePlatformDisconnect(platform.slug)
                : null
            }
          >
            {loading ? "Disconnecting..." : "Disconnect"}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default ConnectedPlatformCard;
